<template>
  <TitleWrapper
    :filter-option="true"
    title="DAILY_STAFF_ATTENDANCE"
    tooltip-title="DAILY_STAFF_ATTENDANCE"
    :display-breadcrumb="true"
    :displayed-column-options="csvFilterOptions"
    :already-selected-displayed-column="filtersPayload.displayedColumns"
    :count="filtersCount"
    @cancel="cancelHanlder"
    @applyFilter="emitFiltersPayload($event, invalid)"
    @clear="clearFilters"
  >
    <template v-slot:filterItems>
      <InputFieldWrapper layout-mode="true">
        <UiMultiSelect
          v-model.trim="filtersPayload.user_id"
          title="STAFF"
          :options="staffList"
          reduce="id"
          label="full_name"
          input-color="bg-white"
          :already-selected="selectedStaff"
          :search-through-api="true"
          :filter="FILTERS_LIST.MULTIPLE_USERS"
          @search="getStaff"
          @emitQuery="updateQuery"
        />
        <UiSingleSelect
          v-model="filtersPayload.status"
          title="STATUS"
          :options="attendanceStatusOptions"
          input-color="bg-white"
          label="title"
          reduce="value"
          :filter="FILTERS_LIST.STATUS"
          @emitQuery="updateQuery"
        />
      </InputFieldWrapper>
    </template>
  </TitleWrapper>
</template>

<script>
import { TENANT_ROLES } from '@/src/constants/user-roles-constants'
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import TitleWrapper from '@components/TitleWrapper.vue'
import { getCountFromObject, pluralToSingular } from '@utils/generalUtil'
import FILTER_KEYS, { FILTERS_LIST } from '@src/constants/filter-constants.js'
import { mapActions, mapState, mapGetters } from 'vuex'
import filterMixins from '@/src/mixins/filter-mixins.js'
import { buildWhereQuery } from '@/src/utils/filters'
import { ATTENDANCE_STATUSES } from '@src/constants/attandance/attandance-constant.js'
import UiMultiSelect from '@/src/components/UiElements/UiMultiSelect.vue'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'

export default {
  components: {
    UiMultiSelect,
    UiSingleSelect,
    TitleWrapper,
    InputFieldWrapper,
  },
  mixins: [filterMixins],
  props: {
    csvFilterOptions: {
      type: Array,
      default: () => [],
    },
    alreadySelectedDisplayedColumns: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      ATTENDANCE_STATUSES,
      FILTER_KEYS,
      staffList: [],
      $where: {},
      selectedStaff: [],
      FILTERS_LIST,
      filtersPayload: {
        status: '',
        user_id: [],
        displayedColumns: [],
      },
      filtersCount: 0,
    }
  },

  computed: {
    checkRoleEligibility() {
      const userSelectedRole = this.activeRole || ''
      switch (userSelectedRole) {
        case TENANT_ROLES.SECTION_STUDENT:
        case TENANT_ROLES.GUARDIAN:
          return false
        default:
          return true
      }
    },
    attendanceStatusOptions() {
      return [...this.ATTENDANCE_STATUSES, { title: 'Tardy', value: 'tardy' }]
    },

    ...mapState({
      currentCampusScope: (state) => state.layout.currentCampusScope.id,
      activeRole: (state) => state.layout.activeRole,
    }),
  },
  watch: {
    currentCampusScope: {
      handler() {
        this.getStaff()
        this.clearFilters()
      },
    },
  },
  mounted() {
    this.getStaff()
  },
  methods: {
    pluralToSingular,
    getStaff(query) {
      if (!this.checkRoleEligibility) return
      let alreadySelectedStaff = []
      const payload = {
        $where: {
          ...buildWhereQuery(FILTER_KEYS.ILIKE, 'search', query),
        },
      }
      this.fetchStaffAndTeacherList(payload).then((res) => {
        this.staffList = res?.records
        this.staffList?.forEach((record) => {
          if (this.filtersPayload && this.filtersPayload.user_id.length) {
            this.filtersPayload.user_id.forEach((id) => {
              if (record.id === id) {
                alreadySelectedStaff.push(record)
              }
            })
          }
          this.selectedStaff = alreadySelectedStaff
        })
      })
    },
    getFiltersCount() {
      this.getStaff()
      return getCountFromObject(this.filtersPayload, 'displayedColumns', 'boolean')
    },
    ...mapActions('staff', ['getStaffDailyAttendanceList', 'fetchStaffAndTeacherList']),
  },
}
</script>
